<template>
  <svg xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 18 18" 
    fill="currentColor"
    preserveAspectRatio="xMidYMid">
    <path d="M18.796 16.904l-4.378-4.378a7.892 7.892 0 001.467-4.583C15.885 3.563 12.322 0 7.943 0 3.563 0 0 3.563 0 7.943c0 4.38 3.563 7.943 7.943 7.943a7.89 7.89 0 004.583-1.467l4.378 4.377 1.892-1.892zM7.943 13.209a5.272 5.272 0 01-5.267-5.266 5.272 5.272 0 015.267-5.267 5.272 5.272 0 015.266 5.267 5.272 5.272 0 01-5.266 5.266z"></path>
  </svg>
</template>